import dayjs from "dayjs";
import {convertDateStringToDateTimezone_7Dayjs} from "helper/common";

const getTodayString = (data?) => {
  return convertDateStringToDateTimezone_7Dayjs(
    data,
    `HH:mm - [Ngày] DD [tháng] MM [năm] YYYY`
  );
};
const serviceColumns: any = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    render: (v, r, i) => i + 1,
    width: "4%",
    align: "center",
  },
  {
    title: "Dịch vụ khám",
    key: "dichVuKham",
    dataIndex: "dichVuKham",
    align: "left",
  },
  {
    title: "Số lượng",
    key: "soLuong",
    dataIndex: "soLuong",
    align: "center",
    width: "12%",
  },
];

export {serviceColumns, getTodayString};
